module.exports = __webpack_public_path__ + "img/BrewOL2.e3598199.jpg";